import React, { useState } from "react";
import { RxAvatar } from "react-icons/rx";
import { getCookie } from "../../../function";
import { jwtDecode } from "jwt-decode";

const Header = () => {
  const [token, setToken] = useState(getCookie("token"));

  // Decode the JWT and extract user info, such as role
  const decodedToken = token ? jwtDecode(token) : null;

  return (
    <div className="header_main d-flex justify-content-between align-items-center px-3">
      <div></div>
      <div className="d-flex align-items-center">
        <RxAvatar className="me-2" />
        <span>
          {decodedToken?.user?.first_name} {decodedToken?.user?.last_name}
        </span>
      </div>
    </div>
  );
};

export default Header;
